module.exports = __webpack_public_path__ + "static/media/Verdana-01.cfefd654.svg";